import React from "react";
import { styled } from "@mui/system";
import { colors } from "../config/colors";

const NoRowsOverlayStyled = styled("div")({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  height: "100%",
  padding: "20px",
  textAlign: "center",
  "& .icon-circle": {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "48px",
    height: "48px",
    borderRadius: "50%",
    backgroundColor: colors.primary,
    color: colors.white,
    fontSize: "24px",
    fontWeight: "bold",
    marginBottom: "12px",
  },
  "& .empty-title": {
    fontSize: "16px",
    fontWeight: "600",
    color: colors.textPrimary,
    marginBottom: "8px",
  },
  "& .empty-subtitle": {
    fontSize: "14px",
    color: colors.textSecondary,
  },
});

/**
 * NoRowsOverlay Component - Shared component for AG Grid empty state
 * @param {string} title - Empty state title message
 * @param {string} subtitle - Empty state subtitle/description
 */
export const NoRowsOverlay = ({ 
  title = "No data found", 
  subtitle = "Try adjusting your filters" 
}) => (
  <NoRowsOverlayStyled>
    <div className="icon-circle">i</div>
    <div className="empty-title">{title}</div>
    <div className="empty-subtitle">{subtitle}</div>
  </NoRowsOverlayStyled>
);

export default NoRowsOverlay;
